export default function CandidatesBoardLoading() {
  return (
    <div className="hidden-scrollbar h-[calc(100vh_-_166px)] min-w-[248px] rounded bg-[#EAEAEA] px-3 py-4">
      <div className="hidden-scrollbar mt-x3l flex max-h-[calc(100vh_-_237px)] w-full flex-col gap-2 overflow-hidden overflow-y-auto">
        {Array.from({ length: 10 }).map((_, i) => {
          return <div key={i} className="min-h-[105px] w-full rounded bg-gray-50"></div>;
        })}
      </div>
    </div>
  );
}
